/**
 * Google Ads (gtag.js) segédfüggvények.
 *
 * A gtag.js loader és a Consent Mode v2 alapállapot a public/index.html <head>-jében van,
 * mert a hozzájárulás alapértelmezését a tag betöltése ELŐTT kell beállítani. Ez a modul
 * csak a futásidejű hívásokat fogja össze, hogy az azonosítók egy helyen legyenek.
 */

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export const GTAG_ID = "AW-17709112840";
export const CONVERSION_AJANLATKERES = "AW-17709112840/eyrjCOnmjLsbEIi8rvxB";

const CONSENT_KEY = "hk-cookie-consent";
const CONVERSION_SENT_KEY = "hk-conv-ajanlatkeres";

export type ConsentValue = "granted" | "denied";

/** Csak akkor hív gtag-et, ha a script tényleg betöltött (adblock, dev, offline eset). */
function gtagSafe(...args: unknown[]): void {
  if (typeof window.gtag === "function") {
    window.gtag(...args);
  }
}

/** A korábban elmentett döntés, vagy null ha még nem döntött a látogató. */
export function getStoredConsent(): ConsentValue | null {
  try {
    const value = localStorage.getItem(CONSENT_KEY);
    return value === "granted" || value === "denied" ? value : null;
  } catch {
    // Privát böngészőmódban / letiltott tárolónál dobhat.
    return null;
  }
}

/**
 * Beállítja a hozzájárulást és elmenti. Minden oldalbetöltéskor újra meg kell hívni a
 * mentett értékkel, mert az index.html mindig "denied" alapállapotból indul.
 */
export function setConsent(value: ConsentValue): void {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {
    // Ha nem tudjuk elmenteni, a sáv újra megjelenik – ez elfogadható.
  }

  gtagSafe("consent", "update", {
    ad_storage: value,
    ad_user_data: value,
    ad_personalization: value,
    analytics_storage: value,
  });
  gtagSafe("set", "ads_data_redaction", value === "denied");
}

/**
 * Elsüti az "Ajánlatkérés" konverziót. Sessionönként egyszer, hogy több kattintás ne
 * fújja fel a Google Ads konverziószámot.
 *
 * @param source honnan jött a kattintás (pl. "E-mail", "Telefon")
 */
export function trackAjanlatkeres(source: string): void {
  try {
    if (sessionStorage.getItem(CONVERSION_SENT_KEY)) {
      return;
    }
    sessionStorage.setItem(CONVERSION_SENT_KEY, source);
  } catch {
    // Tárolóhiba esetén inkább elküldjük az eseményt, mint hogy elveszítsük.
  }

  gtagSafe("event", "conversion", {
    send_to: CONVERSION_AJANLATKERES,
    event_source: source,
  });
}
